import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../..'
import { MODAL_CONFIRM, MODAL_CRASH_BOOKING } from '../../../helpers'
export class ModalCrashBooking extends Component {
  render() {
    const {
      onClickCancel,
      onClickAction,
      colorTheme,
      language
    } = this.props
    return (
      <StyleModal colorTheme={colorTheme}>
        <div className='div-modal' />
        <div className='content-modal'>
          <div className='sub-content'>
            <div className='description'>
              <p>{MODAL_CRASH_BOOKING.DESCRIPTION_HOLIDAY[language]}</p>
              <p>{MODAL_CRASH_BOOKING.DESCRIPTION_CONFIRM[language]}</p>
            </div>
            <div className='table btn-modal'>
              <div className='table-row'>
                <div className='table-cell table-right'>
                  <Button
                    name={MODAL_CONFIRM.KEEP[language]}
                    onClick={onClickCancel}
                    className='modal-btn-cancel'
                  />
                </div>
                <div className='table-cell table-left'>
                  <Button
                    name={MODAL_CONFIRM.OK[language]}
                    onClick={onClickAction}
                    className='modal-btn-confirm'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}
